import { axiosJWT } from 'modules/axios'
import { APP_CONFIG } from 'services/app-config'

export function getPonc(orderId) {
  return axiosJWT({
    method: 'GET',
    url: `${APP_CONFIG.sales_cluster}/v1/orders/${orderId}/ponc`,
  }).then(resp => resp.data)
}
